import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM12.75 2.001C12.75 1.58679 12.4142 1.251 12 1.251C11.5858 1.251 11.25 1.58679 11.25 2.001H12.75ZM11.25 16.001C11.25 16.4152 11.5858 16.751 12 16.751C12.4142 16.751 12.75 16.4152 12.75 16.001H11.25ZM16.4697 7.53133C16.7626 7.82422 17.2375 7.82422 17.5304 7.53133C17.8232 7.23844 17.8232 6.76356 17.5304 6.47067L16.4697 7.53133ZM11.999 2L12.5294 1.46967C12.3887 1.32901 12.1979 1.24999 11.999 1.25C11.8001 1.25001 11.6093 1.32905 11.4686 1.46972L11.999 2ZM6.46864 6.47072C6.17578 6.76364 6.17582 7.23852 6.46875 7.53138C6.76167 7.82425 7.23654 7.8242 7.52941 7.53128L6.46864 6.47072ZM20 19.25H4V20.75H20V19.25ZM11.25 2.001V16.001H12.75V2.001H11.25ZM17.5304 6.47067L12.5294 1.46967L11.4687 2.53033L16.4697 7.53133L17.5304 6.47067ZM11.4686 1.46972L6.46864 6.47072L7.52941 7.53128L12.5294 2.53028L11.4686 1.46972Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;
